// Shared blocked attachment types for rendering and download logic
export const BLOCKED_ATTACHMENT_TYPES = ['image/svg+xml', 'image/svg'];
